interface ReferenceObjectSelectorProps {
  onObjectSelected: (objectType: string, lengthInches: number) => void;
}

const REFERENCE_OBJECTS = [
  { id: 'pen', name: 'Pen', length: 5.5 },
  { id: 'credit-card', name: 'Credit Card', length: 3.37 },
  { id: 'dollar-bill', name: 'Dollar Bill', length: 6.14 },
  { id: 'smartphone', name: 'Smartphone (6")', length: 6.0 },
  { id: 'custom', name: 'Custom', length: 0 },
];

export function ReferenceObjectSelector({ onObjectSelected }: ReferenceObjectSelectorProps) {
  const handleSelect = (objectType: string, length: number) => {
    if (objectType === 'custom') {
      const customLength = prompt('Enter the length of your reference object in inches:');
      if (customLength && !isNaN(parseFloat(customLength))) {
        onObjectSelected('custom', parseFloat(customLength));
      }
    } else {
      onObjectSelected(objectType, length);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Set Reference Object
        </h2>
        <p className="text-sm text-gray-600 mb-6">
          Place a common object in the frame to calibrate measurements. You'll click both ends of this object.
        </p>

        <div className="space-y-3">
          {REFERENCE_OBJECTS.map((obj) => (
            <button
              key={obj.id}
              onClick={() => handleSelect(obj.id, obj.length)}
              className="w-full flex items-center gap-4 p-4 rounded-xl border-2 border-gray-200 hover:border-blue-500 hover:bg-blue-50 transition-all"
            >
              <div className="flex-1 text-left">
                <div className="font-semibold text-gray-900">{obj.name}</div>
                {obj.length > 0 && (
                  <div className="text-sm text-gray-500">
                    {obj.length}" ({(obj.length * 2.54).toFixed(1)} cm)
                  </div>
                )}
              </div>
            </button>
          ))}
        </div>

        <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <p className="text-sm text-blue-900">
            <strong>Tip:</strong> For best accuracy, use a pen or credit card and place it flat in the frame at the same distance as what you want to measure.
          </p>
        </div>
      </div>
    </div>
  );
}
